<template>
  <div class="page-content">
    <page-template
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
    ></page-template>
  </div>
</template>
<script>
import pageTemplate from "@/components/template/pageTemplate";
import api from "@/config/api";
import userPower from "@/mixin/userPower";

export default {
  mixins: [userPower],
  components: {
    pageTemplate,
  },
  data() {
    return {
      dialogVisibility: false,
      // 高级搜索条件
      searchOptions: {
        simple: [
          {
            label: '礼品编码或名称',
            prop: 'otherName',
            type: 'input',
            placeholder: '请输入礼品编码或名称',
            labelWidth: '110'
          },
        ],
      },
      // 更多功能
      toolConfig: [],
      // 表格信息配置
      tableOptions: {
        columns: [
          {label: '订单号', prop: 'orderNo', width: '120', align: 'center'},
          {label: '会员手机', prop: 'memberPhone', width: '100', align: 'center'},
          {label: '会员姓名', prop: 'memberName', width: '100', align: 'center'},
          {
            label: '礼品编码',
            prop: 'barCode',
            width: '140',
            align: 'center',
          },
          {label: '礼品名称', prop: 'goodsName', width: '100', align: 'center'},
          {label: '兑换数量', prop: 'exchangeNum', width: '100', align: 'center'},
          {label: '消耗积分', prop: 'consumptionIntegral', width: '100', align: 'center'},
          {label: '兑换门店', prop: 'storeName', width: '100', align: 'center'},
          {label: '兑换时间', prop: 'createDttm', width: '140', align: 'center'},
        ],
        url: api.member.mbIntegralGiftRecord
      },
    };
  },
  created() {
  },
  methods: {},
};
</script>




// WEBPACK FOOTER //
// src/page/member/integral/GiftDetail.vue